import { budgetTypesEnum } from './constants'

export const originSection = () => {
  const path = location.pathname

  if (path.includes('attendance')) {
    return 'Time tracking section'
  } else if (path.includes('contributors')) {
    return 'People section'
  } else {
    return 'My projects section'
  }
}

export const isValidBudgetType = (budgetType: string): budgetType is budgetTypesEnum => {
  return [
    'fixed_time_budget',
    'fixed_cost_planning',
    'project_fixed_cost',
    'total_budget',
    'without_budget',
  ].includes(budgetType)
}
